import { AnswersDTO, StepId } from '../../api/useRiskToleranceWorkflowQuery';

export interface OnSubmitParams {
  stepId: StepId;
  answer: number;
}

export interface StepProps {
  answers: AnswersDTO;
  onPrevious(): void;
  onNext(): void;
  onSubmit(params: OnSubmitParams): void;
  submitAnswers(answers: AnswersDTO): void;
  progress: number;
}

export const defaultAnswers: AnswersDTO = {
  [StepId.InvestmentObjective]: 1,
  [StepId.TimeHorizon]: 1,
  [StepId.HypotheticalPortfolio]: 1,
  [StepId.RiskLevel]: 6,
  [StepId.DownMarket]: 1,
  [StepId.IncomeStability]: 1,
  [StepId.EmergencyHandling]: 1,
};
